import $http from '$http'
import {
    util
} from 'utils';
import {
    lg
} from 'utils';

export default {
    methods: {
        //POST /api/AgentAreas/AddAgentArea
        AddAgentArea(data) {
            this.loading = true;
            $http.post('api/AgentAreas/AddAgentArea', data).then(res => {
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });

                    this.$emit('reload-list');
                    this.close();
                });
            });
        },
        // 获取单条
        GetByCustomerAreaId(CustomerId, AgentAreaId) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: CustomerId,
                AgentAreaId: AgentAreaId
            };
            $http.get('api/NewAgent/GetById', Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    // this.form = Data
                    this.form.Id = this.id
                    this.baseInfo = Data.Customer;
                    this.contact = Data.Contact;
                    this.agentList = Data.List
                    this.form.IsUpdateContactOrCustomer = this.contact.IsUpdateContactOrCustomer
                    //this.AgentAreaId = Data.List[0].Id
                    if (this.contact.IsUpdateContactOrCustomer == 1) {
                        this.isShow = true
                    }
                });
            });
        },
        GetById() {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: this.CustomerId
            };

            $http.get('api/NewAgent/GetById', Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {

                    this.baseInfo = Data.Customer;
                    this.contact = Data.Contact;

                });
            });
        },
        // 修改提交POST /api/AgentAreas/UpdateAgentArea
        UpdateAgentArea(data) {
            this.loading = true;

            $http.post('api/AgentAreas/UpdateAgentArea', data).then(res => {
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });

                    this.$emit('reload-list');
                    this.close();
                });
            });
        },
        // 判断是不是只代理hi幼教意向级别
        GetAgentAreaList(Id) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: Id //代理商id
            };

            $http.get('api/AgentAreas/GetAgentAreaList', Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    let len = Data.AgentAreaList.length
                    this.CustomerId = Data.CustomerId
                    for (let i = 0; i < len; i++) {
                        if (Data.AgentAreaList[i].RebateLevel == 1 && Data.AgentAreaList[i].ProjectType == 2 && Data.Industry_Id == 9) {
                            this.isOnlyHiInter = true
                        } else {
                            this.isOnlyHiInter = false
                        }
                    }

                    if (this.agentList[0].PolicyType !== undefined) {
                        this.currentLevel = this.agentList[0].PolicyType
                    }
                    if (this.isOnlyHiInter && this.currentLevel !== 1 && this.currentLevel !== '') {
                        this.$alert('需要补充公司信息', '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.isShow = true
                                this.GetById()
                            }
                        });
                        // this.$confirm('需要补充公司信息', '提示', {
                        //     confirmButtonText: '确定',
                        //     type: 'warning'
                        // }).then(() => {
                        //     this.isShow = true
                        //     this.GetById()
                        //     })

                    } else {
                        this.isShow = false
                    }
                });
            });
        },

    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/AgentAreaList/components/AddAreaDialog/services.js